import React from 'react';
import PropTypes from 'prop-types';
import { Paper, ButtonBase, Avatar } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiMessageTextOutline, mdiEmailOutline } from '@mdi/js';
import SideBadge from 'components/SideBadge/SideBadge';

const ChatListItem = React.memo(
  ({
    title,
    classes,
    avatarSrc,
    showAvatar = false,
    showEmailButton = false,
    showChatButton = true,
    projectKey,
    unreadEmailCount = 0,
    unreadChatCount = 0,
    onEmailButtonClick,
    onChatButtonClick,
  }) => {
    return (
      <Paper className={classes.paper}>
        <div className={classes.threadContent}>
          {showAvatar && (
            <Avatar src={avatarSrc} className={classes.avatar}>
              {title ? title.charAt(0).toUpperCase() : ''}
            </Avatar>
          )}
          <div className={classes.threadTitle}>{title || ''}</div>
        </div>
        {showEmailButton && (
          <ButtonBase
            className={classes.chatButton}
            component={RouterLink}
            to={`/project/${projectKey}/email`}
            onClick={onEmailButtonClick}
          >
            <SideBadge
              badgeContent={unreadEmailCount}
              color="secondary"
              invisible={(unreadEmailCount || 0) === 0}
            >
              <Icon path={mdiEmailOutline} size={1} />
            </SideBadge>
          </ButtonBase>
        )}
        {showChatButton && (
          <ButtonBase
            className={classes.chatButton}
            onClick={onChatButtonClick}
          >
            <SideBadge
              badgeContent={unreadChatCount}
              color="secondary"
              invisible={(unreadChatCount || 0) === 0}
            >
              <Icon path={mdiMessageTextOutline} size={1} />
            </SideBadge>
          </ButtonBase>
        )}
      </Paper>
    );
  }
);

ChatListItem.propTypes = {
  title: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  avatarSrc: PropTypes.string,
  showAvatar: PropTypes.bool,
  showEmailButton: PropTypes.bool,
  showChatButton: PropTypes.bool,
  projectKey: PropTypes.string.isRequired,
  unreadEmailCount: PropTypes.number,
  unreadChatCount: PropTypes.number,
  onEmailButtonClick: PropTypes.func,
  onChatButtonClick: PropTypes.func,
};

export default ChatListItem;
